var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"audio",attrs:{"data-loading":_vm.loading}},[_c('audio',{ref:"player",attrs:{"src":_vm.src,"controls":"","controlist":"play timeline"},on:{"play":function($event){return _vm.play($event)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }